import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import GameCard from '@/components/base/GameCard';
import ArticleCard from '@/components/base/ArticleCard';
import { games, articles, categories, faqs, siteInfo } from '@/mocks/siteData';

export default function Home() {
  const hotGames = games.filter((g) => g.isHot);
  const newGames = games.filter((g) => g.isNew);
  const featuredArticles = articles.filter((a) => a.isFeatured);

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Luxury%20gaming%20platform%20hero%20background%20with%20golden%20particles%20and%20warm%20light%20rays%2C%20elegant%20dark%20atmosphere%2C%20premium%20gaming%20ambience%2C%20soft%20glowing%20effects%2C%20rich%20golden%20and%20amber%20accents%2C%20abstract%20luxurious%20composition%2C%20cinematic%20lighting&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
            alt="PG游戏官方平台"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight">
              {siteInfo.name}
            </h1>
            <p className="text-base md:text-lg text-white/80 mb-6 md:mb-8 max-w-2xl mx-auto leading-relaxed">
              {siteInfo.description}立即探索pg游戏的精彩世界，发现最新游戏推荐、独家活动与专业攻略，让每一次游戏体验都超越期待。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
              <a
                href="#"
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-white font-medium text-sm md:text-base hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
              >
                立即开始游戏
              </a>
              <Link
                to="/about"
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg border border-white/40 text-white font-medium text-sm md:text-base hover:bg-white/10 transition-colors duration-200 whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>
            <div className="flex items-center justify-center gap-6 md:gap-10 mt-8 md:mt-10">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-white">1000+</p>
                <p className="text-xs md:text-sm text-white/60">精品游戏</p>
              </div>
              <div className="w-px h-10 bg-white/20"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-white">500万+</p>
                <p className="text-xs md:text-sm text-white/60">活跃玩家</p>
              </div>
              <div className="w-px h-10 bg-white/20"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-white">99.9%</p>
                <p className="text-xs md:text-sm text-white/60">好评率</p>
              </div>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex flex-col items-center gap-2 p-4 md:p-5 rounded-lg bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer group"
                >
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-background-200 group-hover:bg-primary-100 transition-colors duration-200">
                    <i className={`${cat.icon} text-lg md:text-xl text-foreground-700 group-hover:text-primary-600`}></i>
                  </div>
                  <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                    {cat.name}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Games Section */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                  <i className="ri-fire-line text-primary-500 mr-2"></i>
                  热门游戏
                </h2>
                <p className="text-sm text-foreground-500 mt-1">千万玩家的共同选择，体验最受欢迎的游戏</p>
              </div>
              <Link
                to="/category/dianzi-youxi"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {hotGames.map((game) => (
                <GameCard
                  key={game.id}
                  slug={game.slug}
                  name={game.name}
                  categoryName={game.categoryName}
                  rating={game.rating}
                  players={game.players}
                  tags={game.tags}
                  image={game.image}
                  isNew={game.isNew}
                />
              ))}
            </div>
          </div>
        </section>

        {/* New Games Section */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                  <i className="ri-sparkling-line text-accent-500 mr-2"></i>
                  新品推荐
                </h2>
                <p className="text-sm text-foreground-500 mt-1">最新上线的精品游戏，抢先体验</p>
              </div>
              <Link
                to="/category/xin-pin-tuijian"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {newGames.map((game) => (
                <GameCard
                  key={game.id}
                  slug={game.slug}
                  name={game.name}
                  categoryName={game.categoryName}
                  rating={game.rating}
                  players={game.players}
                  tags={game.tags}
                  image={game.image}
                  isNew={game.isNew}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                  <i className="ri-article-line text-primary-500 mr-2"></i>
                  攻略精选
                </h2>
                <p className="text-sm text-foreground-500 mt-1">专业玩家的实战经验，助你提升游戏水平</p>
              </div>
              <Link
                to="/category/dianzi-youxi"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
              >
                更多攻略 <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
            <div className="flex flex-col gap-4">
              {featuredArticles.map((article) => (
                <ArticleCard
                  key={article.id}
                  slug={article.slug}
                  title={article.title}
                  excerpt={article.excerpt}
                  categoryName={article.categoryName}
                  author={article.author}
                  date={article.date}
                  readTime={article.readTime}
                  image={article.image}
                  tags={article.tags}
                />
              ))}
            </div>
          </div>
        </section>

        {/* All Games Section */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="mb-6 md:mb-8">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                <i className="ri-gamepad-line text-primary-500 mr-2"></i>
                全部游戏
              </h2>
              <p className="text-sm text-foreground-500 mt-1">探索PG游戏平台的全部精品游戏</p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {games.map((game) => (
                <GameCard
                  key={game.id}
                  slug={game.slug}
                  name={game.name}
                  categoryName={game.categoryName}
                  rating={game.rating}
                  players={game.players}
                  tags={game.tags}
                  image={game.image}
                  isNew={game.isNew}
                />
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-2">
                常见问题
              </h2>
              <p className="text-sm text-foreground-500">关于PG游戏平台的热门问题解答</p>
            </div>
            <div className="flex flex-col gap-3">
              {faqs.map((faq, index) => (
                <details key={index} className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer">
                  <summary className="flex items-center justify-between px-5 py-4 text-sm md:text-base font-medium text-foreground-800 list-none">
                    <span>{faq.question}</span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200"></i>
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* JSON-LD Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: siteInfo.name,
            url: siteInfo.url,
            description: siteInfo.description,
            potentialAction: {
              '@type': 'SearchAction',
              target: `${siteInfo.url}/search?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: siteInfo.name,
            url: siteInfo.url,
            description: siteInfo.description,
            email: siteInfo.email,
            telephone: siteInfo.phone,
            address: {
              '@type': 'PostalAddress',
              addressLocality: '上海',
              addressCountry: 'CN',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </>
  );
}